import { Delete, LockKeyhole, Loader2 } from "lucide-react";
import { vaultDigit, vaultDelete } from "@/lib/vaultSounds";
import { VaultDoor } from "@/components/vault/VaultDoor";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "del", "0", "ok"];

export function VaultPad({ value, setValue, onSubmit, busy, disabled, shake, door }) {
  const press = (k) => {
    if (k === "del") { if (value) vaultDelete(); return setValue(value.slice(0, -1)); }
    if (k === "ok") return value.length === 4 && onSubmit();
    if (value.length < 4 && !value.includes(k)) { vaultDigit(k); setValue(value + k); }
  };
  return (
    <div className="space-y-4" data-testid="vault-pad">
      <div className={shake ? "vault-shake" : ""}><VaultDoor {...door} /></div>
      <div className={`flex justify-center gap-2.5 ${shake ? "vault-shake" : ""}`}>
        {[0, 1, 2, 3].map((i) => (
          <span key={`${i}-${value[i] || ""}`} data-testid={`vault-slot-${i}`} className={`w-14 h-16 sm:w-16 sm:h-20 rounded-2xl grid place-items-center font-display text-3xl font-black ${value[i] ? "bg-gradient-to-b from-amber-300 to-amber-500 text-slate-900 shadow-[0_0_18px_rgba(251,191,36,0.45)] vault-digit-in" : "bg-slate-800 text-white/20 ring-1 ring-white/10"} ${busy && value[i] ? "vault-slot-busy" : ""}`} style={busy ? { animationDelay: `${i * 90}ms` } : undefined}>{value[i] || "•"}</span>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 max-w-xs mx-auto">
        {KEYS.map((k) => {
          const used = k.length === 1 && value.includes(k);
          const ok = k === "ok";
          return (
            <button key={k} onClick={() => press(k)} disabled={disabled || busy || used || (ok && value.length < 4)} data-testid={`vault-key-${k}`}
              className={`h-14 rounded-2xl font-display text-xl font-black flex items-center justify-center active:scale-90 transition-[transform,background-color,opacity] duration-100 disabled:opacity-35 ${ok ? "bg-gradient-to-br from-amber-300 to-amber-500 text-slate-900 disabled:from-slate-700 disabled:to-slate-700 disabled:text-white/40" : "bg-white/10 hover:bg-white/15 text-white shadow-[inset_0_-3px_0_rgba(0,0,0,0.35)]"} ${ok && value.length === 4 && !busy ? "vault-ok-ready" : ""}`}>
              {k === "del" ? <Delete className="w-5 h-5" /> : ok ? (busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <LockKeyhole className="w-5 h-5" />) : k}
            </button>
          );
        })}
      </div>
      <p className="text-center text-xs text-white/50">4 verschiedene Ziffern · jede Ziffer nur einmal</p>
    </div>
  );
}
